import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SwipeCardsComponent } from './swipe-cards/swipe-cards.component';
import { HowToPlayComponent } from './how-to-play/how-to-play.component';
import { HomeComponent } from './home/home.component';
import { FaqComponent } from './faq/faq.component';
import { TermsComponent } from './terms/terms.component';

@NgModule({
  declarations: [
    AppComponent,
    SwipeCardsComponent,
    HowToPlayComponent,
    HomeComponent,
    FaqComponent,
    TermsComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HammerModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
